import {
  GetClauseDataByType,
  GETCLAUSEDATABYTYPE,
  GETCLAUSEDATABYTYPE_FAILURE,
  GETCLAUSEDATABYTYPE_SUCCESS,
  GetClauseDataByTypeFailure,
  GetClauseDataByTypeSuccess,
  PostClauseDataByType,
  POSTCLAUSEDATABYTYPE,
  POSTCLAUSEDATABYTYPE_FAILURE,
  POSTCLAUSEDATABYTYPE_SUCCESS,
  PostClauseDataByTypeFailure,
  PostClauseDataByTypeSuccess,
  UpdateClauseData,
  UPDATECLAUSEDATA,
} from './def';
import { ClauseType } from '../../../Constants/ClauseType';
import { clauseTypeData } from '../State/clauseComponentState';

export default class ClauseComponentActionGenerator {
  public static getClausDataByType(
    fileID: string,
    type: ClauseType
  ): GetClauseDataByType {
    return {
      type: GETCLAUSEDATABYTYPE,
      payload: {
        fileID: fileID,
        type: type,
      },
    };
  }
  public static getClausDataByTypeSuccess(
    clauseData: clauseTypeData,
    type: ClauseType
  ): GetClauseDataByTypeSuccess {
    return {
      type: GETCLAUSEDATABYTYPE_SUCCESS,
      payload: {
        clauseData: clauseData,
        type: type,
      },
    };
  }
  public static getClausDataByTypeFailure(): GetClauseDataByTypeFailure {
    return {
      type: GETCLAUSEDATABYTYPE_FAILURE,
    };
  }
  public static postClauseDataByType(
    fileID: string,
    type: ClauseType,
    diff: any,
    updatedClauseData: any
  ): PostClauseDataByType {
    return {
      type: POSTCLAUSEDATABYTYPE,
      payload: {
        fileID,
        type,
        diff,
        updatedClauseData,
      },
    };
  }

  public static postClauseDataByTypeSuccess(
    type: ClauseType,
    updatedClauseData: any
  ): PostClauseDataByTypeSuccess {
    return {
      type: POSTCLAUSEDATABYTYPE_SUCCESS,
      payload: {
        type,
        updatedClauseData,
      },
    };
  }

  public static postClauseDataByTypeFailure(): PostClauseDataByTypeFailure {
    return {
      type: POSTCLAUSEDATABYTYPE_FAILURE,
    };
  }

  public static UpdateClauseData(
    clauseData: any,
    type: ClauseType
  ): UpdateClauseData {
    return {
      type: UPDATECLAUSEDATA,
      payload: {
        clauseData,
        type,
      },
    };
  }
}
